import styled from 'styled-components';

const Page = styled.div`
    width: 100%;
    max-width: 1024px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export default Page;
